import { TransactionService } from './../Transaction Components/transaction.service';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';

// import { NgForm, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
// import { Subscription } from "rxjs/Subscription";
import { TrnMain } from '../../common/interfaces/TrnMain';
// import { VoucherTypeEnum } from '../../common/interfaces/TrnMain';
import { BehaviorSubject } from 'rxjs';
// import { Observable } from "rxjs/Observable";
import { MasterRepo } from '../repositories/index';
@Component({
  selector: 'salesPrint',
  templateUrl: './purchasePrint.component.html',
  styles: [],
})
export class PurchasePrintComponent {
  @Input() InvoiceType: string = 'ABBREVIATED Tax Invoice';
  @Input() CompanyName: string = 'DemoCompany Pvt. Ltd.';
  @Input() CompanyAddress: string = 'Tripureswore, Kathmandu';
  @Input() CompanyPan: string = '675845231';
  @Input() printCopyCaption: string = '';
  @Input() TrnMainObj: TrnMain = <TrnMain>{};
  @Output() sendPrefix = new EventEmitter();
  @Input() TrnMainSubject!: BehaviorSubject<any>;
  printData: any;

  constructor(
    public masterService: MasterRepo,
    public _transactionService: TransactionService
  ) {
    console.log({ CONST_PURCHASEPRINT: this.TrnMainSubject });
  }
  ngOnInit() {
    try {
      this._transactionService.PrintStuff$.subscribe((data: any) => {
        this.printData = data;
      });
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }

    // this._data
    //     .subscribe(x => {
    //         this.groupPosts = this.groupByCategory(this.data);
    //     });
  }
}
